import {
    readLatestSelectedOfferDate,
    readLatestSelectedPriceQuoteDate,
} from './formatting';

export const prescriberOrderFields = {
    latestSelectedPriceQuoteDate: { read: readLatestSelectedPriceQuoteDate },
    latestSelectedOfferDate: { read: readLatestSelectedOfferDate },
};
